"use client";
import { Dialog as o } from "@ark-ui/react";
import { dialog as e } from "@huspy/styled-system/recipes";
import { createStyleContext as r } from "../../utils/createStyleContext.mjs";
const { withRootProvider: n, withContext: i } = r(e), s = n(o.Root), a = i(
  o.Backdrop,
  "backdrop"
), g = i(o.CloseTrigger, "closeTrigger"), l = i(
  o.Content,
  "content"
), c = i(o.Description, "description"), p = i(
  o.Positioner,
  "positioner"
), d = i(
  o.Title,
  "title"
), D = i(
  o.Trigger,
  "trigger"
), t = {
  Context: o.Context,
  Backdrop: a,
  CloseTrigger: g,
  Content: l,
  Description: c,
  Positioner: p,
  Root: s,
  Title: d,
  Trigger: D
};
t.Backdrop.displayName = "DialogBackdrop";
t.CloseTrigger.displayName = "DialogCloseTrigger";
t.Content.displayName = "DialogContent";
t.Description.displayName = "DialogDescription";
t.Positioner.displayName = "DialogPositioner";
t.Title.displayName = "DialogTitle";
t.Trigger.displayName = "DialogTrigger";
export {
  t as Dialog
};
